import moment from "moment";
import UAParser from "ua-parser-js";
import {AutoVisit, AutoVisitStatusV2, Cargo, CargoV2} from "~/apps/packages/auto-visits/queries";
import {humanizeVehicleNumber} from "~/apps/core/ui/VehicleNumber";


export function canEditAutoVisit(av: Pick<AutoVisit, "Status">) {
    const EDITABLE_STATUSES: AutoVisit["Status"][] = [
        "planned"
    ];
    return EDITABLE_STATUSES.includes(av.Status);
}


export function formatWeight(value: number): string {
    const splitChar = ' ';
    const [_, int, float] = String(value).match(/^(\d+)(\.\d+)?/);
    return int.split('').reverse()
        .reduceRight((a, v, i) => (i % 3 == 0 && i > 0 ? [splitChar, v].concat(a) : [v].concat(a)), [])
        .reverse().join('') + (float || "");
}


export function humanizeCargoDirection(direction: Cargo["Direction"] | CargoV2["direction"]) {
    const mapping = {
        Export: "Вывоз",
        Import: "Завоз",
        Transit: "Транзит"
    }
    return mapping[direction] || (direction.charAt(0).toUpperCase() + direction.slice(1).toLowerCase());
}

export function humanizeCargoType(type) {
    return type;
}


export type ShareAutoVisit = Pick<AutoVisit, "ID" | "PIN" | "Date" | "TimeSlot" | "Driver" | "Vehicle" | "CargoInfo" | "CheckPoint">
export function getAutoVisitShareData(autoVisit: ShareAutoVisit, format: "share") : ShareData
export function getAutoVisitShareData(autoVisit: ShareAutoVisit, format: "text") : string
export function getAutoVisitShareData(autoVisit: ShareAutoVisit, format: "share" | "text" = "share"): ShareData | string {
    function formatTime(s: string) {
        return moment(s, "HH:mm:ss").format("HH:mm");
    }

    const text =
        `Автовизит: ${autoVisit.ID}\n` +
        `ПИН-код: ${autoVisit.PIN}\n` +
        `\n` +
        `Дата визита: ${moment(autoVisit.Date, "YYYY-MM-DD").format("DD.MM.YYYY")} ${formatTime(autoVisit.TimeSlot.StartTime)}-${formatTime(autoVisit.TimeSlot.EndTime)}\n` +
        `КПП: ${autoVisit.CheckPoint.Name}\n` +
        `\n` +
        `Водитель: ${autoVisit.Driver.Name}\n` +
        `Машина: ${humanizeVehicleNumber(autoVisit.Vehicle.ID)}\n` +
        `Груз: ${autoVisit.CargoInfo}`
    const browser = new UAParser().getBrowser().name;

    if (format == "text") {
        return text;
    }

    if (browser.match(/firefox/i)) {
        return {title: text};
    } else {
        return {text: text};
    }
}


export function compareByField<T>(fieldName: keyof T) {
    return (a: T, b: T) => {
        return a[fieldName] < b[fieldName] ? -1 : 1;
    }
}


export function distinctByField<E extends object>(array: E[], fieldName: keyof E): E[] {
    const keys = new Set();
    return array.filter(item => {
        if (keys.has(item[fieldName])) {
            return false;
        }
        keys.add(item[fieldName]);
        return true;
    })
}


export function getAutoVisitStatusColor(status: AutoVisitStatusV2) {
    const COLOR_MAP: {[key in AutoVisitStatusV2]: any} = {
        "На согласовании": "#DA7C0F",
        "Запланирован": "#3F79B5",
        "Завершен": "#32A71F",
        "Отменен": "#6E798C",
        "Ошибка": "#E53328",
        "В порту": "#009ACF",
        "Неопределен": "#6E798C",
    }
    return COLOR_MAP[status];
}